import {NgModule} from '@angular/core';
import {MaterialModule} from '@angular/material';
import {MdInputModule} from '@angular/material';
import {BrowserModule} from '@angular/platform-browser';
import {BrowserAnimationsModule} from '@angular/platform-browser/animations';
import {NoopAnimationsModule} from '@angular/platform-browser/animations';
import {FormsModule} from '@angular/forms';
import {ReactiveFormsModule} from '@angular/forms';
import {HttpModule} from '@angular/http';
import {MdDatepickerModule, MdNativeDateModule} from '@angular/material';
import {AppRoutingModule} from './app-routing.module';
import {DatePipe} from '@angular/common';
import 'hammerjs';
import {AppComponent} from './app.component';
import {ProductInsertComponent} from './product-insert.component';
import {LeftMenuComponent} from './left-menu.component';
import {DashboardComponent} from './dashboard.component';
import {ProductsCategoryComponent} from './products-category.component';
import {ReceipStock} from './receip-stock.component';
import {IssueStock} from './issue-stock.component';
import {ProductsListComponent} from './products-list.component';
import {ProductsAbstractComponent} from './products-abstract.component';
import {IssueReceiptStock} from './receipt-issue-stock.component';
import {ReceiptStock2} from './receipt-stock.component_2';
import {IssueStock2} from './issue-stock.component_2';
import {Docket} from './docket.component';
import {SupplierListComponent} from './suppliers-list.component';
import {AuthentificationComponent} from './authentification.component';
import {UsersComponent} from './users.component';
import {SuperUsersComponent} from './super_users.component';
import {DialogComponent} from './dialog.component';
import {SuperUsersAuthentificationComponent} from './super_users_authentification.component';
import {MyDatePickerModule} from 'mydatepicker';
import {LeftMenuSudoComponent} from './left-menu-sudo.component';
import {OrderFormProviderComponent} from './order-form-provider.component';
import {InfoOrderFormProviderComponent} from './info-order-form-provider.component';
import {EnterInOrderFormProviderComponent} from './enter-in-order-form-provider.component';
import {PurchasingList} from './purchasing-list.component';
import {PurchasingOrder} from './purchasing-order.component';
import {OutOfWareList} from './out-of-ware-list.component';
import {OutOfWareOrder} from './out-of-ware-order.component';
import {OutInOrderFromOutOfWare} from './out-in-order-from-out-of-ware.component';
import {StockAvailibilityComponent} from './stock-availibility.component';
import {SortTable} from './sort-table.component';

import {MdCheckboxModule} from '@angular/material';
import {MdAutocompleteModule} from '@angular/material';

import {StockAvailibilityService} from './stock-availibility.service';
import {ImportItemsComponent} from './import-items.component';
import {ImportItemsService} from './import-items.service';
import {LocationComponent} from './location.component';
import {LocationService} from './location.service';
import {LocationDocketComponent} from './location-docket.component';
import {LocationsComponent} from './locations.component';
import {InventoryComponent} from './inventory.component';
import {InventoryService} from './inventory.service';
import {InventoriesListComponent} from './inventories-list.component';
import {FileDownloadService} from './file-download.service';
import {ProductMofifyComponent} from './product-modify.component';

import {TruncatePipe} from './truncate.pipe';

import {ActionsComponent} from './actions.component';
import {ActionsService} from './actions.service';
import {EntityComponent} from './entity.component';
import {OrderFromClientComponent} from './order-from-client.component';
import {ReturnFromClientComponent} from './return-from-client.component';
import {ReturnFromSupplierComponent} from './return-from-supplier.component';
import {RemainsToDeliverClientComponent} from './remains-to-deliver-client.component';
import {RemainsToDeliverSupplierComponent} from './remains-to-deliver-supplier.component';
import {DetailsForClientComponent} from './details-for-client.component';
import {DetailsForSupplierComponent} from './details-for-supplier.component';
import {InventoryManagementComponent} from './inventory-management.component';
import {InventoryAnalysisComponent} from './inventory-analysis.component';
import {StatisticComponent} from './statistic.component';

import {MdTabsModule} from '@angular/material';
import {StatisticTopFiveComponent} from './statistic-top-five.component';
import {StatisticRepartitionComponent} from './statistic-repartition.component';
import {StatisticEvolutionComponent} from './statistic-evolution.component';

import {MdProgressBarModule} from '@angular/material';
import {LocationManagerComponent} from './location-manager.component';
import {StockArticleComponent} from './stock-article.component';
import {StockArticleService} from './stock-article.service';
import {StockInitialComponent} from './stock-initial.component';
import {EnterStockComponent} from './enter-stock.component';


import {DateAdapter, MD_DATE_FORMATS} from '@angular/material';
import {AppDateAdapter, APP_DATE_FORMATS} from './app-date.adapter';
import {SendMailComponent} from './send-mail.component';
import {SendMailService} from './send-mail.service';
import {TransferRequestComponent} from './transfer-request.component';
import {TransferRequestService} from './transfer-request.service';

import {ChartsModule} from 'ng2-charts';
import {StockAssessmentComponent} from './stock-assessment.component';
import {ReleaseOrderComponent} from './release-order.component';
import {ReleaseOrderService} from './release-order.service';
import {ArticleReleaseComponent} from './article-release.component';
import {ArticleReleaseService} from './article-release.service';
import {EntityService} from './entity.service';
import {StockStatusComponent} from './stock-status.component';
import {PlacementService} from './placement.service';
import {PlacementDocketComponent} from './placement-docket.component';
import {PlacementDetailsComponent} from './placement-details.component';
import {LocationFormComponent} from './location-form.component';
import {MdExpansionModule} from '@angular/material';
import {EntrepotComponent} from './entrepot.component';
import { ProductInsertService } from './product-insert.service';

@NgModule({
    imports: [
        BrowserModule,
        MyDatePickerModule,
        AppRoutingModule,
        MdInputModule,
        BrowserAnimationsModule,
        NoopAnimationsModule,
        FormsModule,
        ReactiveFormsModule,
        MaterialModule,
        HttpModule,
        MdCheckboxModule,
        MdDatepickerModule,
        MdNativeDateModule,
        MdTabsModule,
        MdProgressBarModule,
        ChartsModule,
        MdAutocompleteModule,
        MdExpansionModule
    ],
    /*entryComponents: [
        DialogComponent
    ],*/
    declarations: [AppComponent,
        ProductInsertComponent,
        LeftMenuComponent,
        DashboardComponent,
        ProductsCategoryComponent,
        ProductsListComponent,
        ReceipStock,
        IssueStock,
        ProductsAbstractComponent,
        IssueReceiptStock,
        ReceiptStock2,
        IssueStock2,
        Docket,
        SupplierListComponent,
        AuthentificationComponent,
        UsersComponent,
        SuperUsersComponent,
        DialogComponent,
        SuperUsersAuthentificationComponent,
        LeftMenuSudoComponent,
        OrderFormProviderComponent,
        InfoOrderFormProviderComponent,
        EnterInOrderFormProviderComponent,
        PurchasingList,
        PurchasingOrder,
        OutOfWareList,
        OutOfWareOrder,
        OutInOrderFromOutOfWare,
        StockAvailibilityComponent,
        ImportItemsComponent,
        LocationComponent,
        LocationDocketComponent,
        InventoryComponent,
        InventoriesListComponent,
        SortTable,
        TruncatePipe,
        ProductMofifyComponent,
        ActionsComponent,
        EntityComponent,
        OrderFromClientComponent,
        ReturnFromClientComponent,
        ReturnFromSupplierComponent,
        RemainsToDeliverClientComponent,
        DetailsForClientComponent,
        InventoryManagementComponent,
        InventoryAnalysisComponent,
        RemainsToDeliverSupplierComponent,
        DetailsForSupplierComponent,
        StatisticComponent,
        StatisticTopFiveComponent,
        StatisticRepartitionComponent,
        StatisticEvolutionComponent,
        LocationManagerComponent,
        StockArticleComponent,
        StockInitialComponent,
        SendMailComponent,
        EnterStockComponent,
        TransferRequestComponent,
        StockAssessmentComponent,
        ReleaseOrderComponent,
        ArticleReleaseComponent,
        StockStatusComponent,
        LocationsComponent,
        PlacementDocketComponent,
        PlacementDetailsComponent,
        LocationFormComponent,
        EntrepotComponent,
    ],
    bootstrap: [AppComponent],
    providers: [
        StockAvailibilityService,
        ImportItemsService,
        LocationService,
        InventoryService,
        FileDownloadService,
        ActionsService,
        MdDatepickerModule,
        MdNativeDateModule,
        DatePipe,
        StockArticleService,
        SendMailService,
        {
            provide: DateAdapter, useClass: AppDateAdapter
        },
        {
            provide: MD_DATE_FORMATS, useValue: APP_DATE_FORMATS
        },
        TransferRequestService,
        ReleaseOrderService,
        ArticleReleaseService,
        EntityService,
        PlacementService,
        ProductInsertService
    ]
})
export class AppModule {

}



// WEBPACK FOOTER //
// ./src/app/app.module.ts